import api from "./api";

// Capa de servicios API del dominio "mensajes" (WhatsApp) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Envío / listado por ticket ---
export const sendMessage = (ticketId, payload, config) =>
  api.post(`/messages/${ticketId}`, payload, config);
export const listMessages = (ticketId, params) =>
  api.get(`/messages/${ticketId}`, { params });

// --- Acciones sobre un mensaje ---
export const editMessage = (messageId, payload) =>
  api.post(`/messages/edit/${messageId}`, payload);
export const deleteMessage = (messageId) => api.delete(`/messages/${messageId}`);
export const updateMessage = (messageId) => api.put(`/messages/${messageId}`);
export const addMessageReaction = (messageId, payload) =>
  api.post(`/messages/${messageId}/reactions`, payload);

// --- Media / consultas globales ---
export const uploadMessageMedia = (formData, config) =>
  api.post("/messages/media-upload", formData, config);
export const getAllMyMessages = (params) =>
  api.get("/messages-allMe", { params });

// Reenvío de mensaje (ForwardMessageModal).
export const forwardMessage = (payload) => api.post("/message/forward", payload);
